import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import queryString from "query-string";
import { useCentralStore } from "stores";

export const deleteSendMessages = ({ churchId, messageIds }) => {
  const messageIdQueries = queryString.stringify(
    { id: messageIds },
    { arrayFormat: "index" }
  );

  return axios.delete(
    `/churches/${churchId}/send-messages?${messageIdQueries}`
  );
};

export const useDeleteSendMessages = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["send-messages"]);
      queryClient.invalidateQueries(["messages"]);
      setNotification({
        type: "success",
        message: "Messages deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteSendMessages
  });
};
